<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Guardrail Library › LLM Powered"
      pageSubtitle="Track latency, cost, behaviors side by side."
    ></app-navbar>

    <div class="content">
      <div class="toolbar">
        <span class="toolbar-text">{{ enabledCount() }} of {{ guardrails().length }} guardrails enabled</span>
        <div class="toolbar-actions">
          <app-button variant="secondary" size="sm" (clicked)="openTest()">
            Test Guardrails
          </app-button>
          <app-button variant="primary" size="sm" (clicked)="saveConfiguration()" [disabled]="saving()">
            {{ saving() ? 'Saving...' : 'Save Configuration' }}
          </app-button>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <div>
            <h3>Input Guardrails</h3>
          </div>
          <span class="section-count">{{ inputGuardrails().length }} guardrails</span>
        </div>
        <app-empty-state
          *ngIf="!inputGuardrails().length"
          title="No data yet"
          message="There are no input guardrails configured yet."
        ></app-empty-state>
        <div class="guardrail-grid" *ngIf="inputGuardrails().length">
          <div class="guardrail-card" *ngFor="let g of inputGuardrails()" (click)="openConfig(g)">
            <div class="card-top">
              <div class="card-title-row">
                <h3 class="card-title">{{ g.name }}</h3>
                <span class="type-badge">{{ g.type }}</span>
              </div>
              <button
                class="toggle"
                [class.on]="g.enabled"
                (click)="onToggleEnabled(g, $event)"
                [attr.aria-label]="(g.enabled ? 'Disable ' : 'Enable ') + g.name"
              >
                <span class="toggle-knob"></span>
              </button>
            </div>

            <p class="card-desc">{{ g.description }}</p>

            <div class="card-footer">
              <span class="card-summary">{{ summaryFor(g) }}</span>
              <app-button variant="secondary" size="sm" (clicked)="openConfig(g)">Configure</app-button>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <div>
            <h3>Output Guardrails</h3>
          </div>
          <span class="section-count">{{ outputGuardrails().length }} guardrails</span>
        </div>
        <app-empty-state
          *ngIf="!outputGuardrails().length"
          title="No data yet"
          message="There are no output guardrails configured yet."
        ></app-empty-state>
        <div class="guardrail-grid" *ngIf="outputGuardrails().length">
          <div class="guardrail-card" *ngFor="let g of outputGuardrails()" (click)="openConfig(g)">
            <div class="card-top">
              <div class="card-title-row">
                <h3 class="card-title">{{ g.name }}</h3>
                <span class="type-badge">{{ g.type }}</span>
              </div>
              <button
                class="toggle"
                [class.on]="g.enabled"
                (click)="onToggleEnabled(g, $event)"
                [attr.aria-label]="(g.enabled ? 'Disable ' : 'Enable ') + g.name"
              >
                <span class="toggle-knob"></span>
              </button>
            </div>

            <p class="card-desc">{{ g.description }}</p>

            <div class="card-footer">
              <span class="card-summary">{{ summaryFor(g) }}</span>
              <app-button variant="secondary" size="sm" (clicked)="openConfig(g)">Configure</app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-guardrail-config-modal
    *ngIf="activeGuardrail() as active"
    [guardrail]="active"
    (closed)="closeModal()"
    (saved)="onSave($event)"
  ></app-guardrail-config-modal>

  <app-guardrail-test-modal
    *ngIf="testModalOpen()"
    (closed)="closeTest()"
  ></app-guardrail-test-modal>
</div>
